import React, { useState } from "react";
import Slider from "./Slider"; // Assuming Slider is your component
import "animate.css";
import NB from "./NB";

const SimulateurEpargne = ({ titre }) => {
  const [initialAmount, setInitialAmount] = useState(50000); // Montant initial de l'épargne
  const [annualInterestRate, setAnnualInterestRate] = useState(1); // Taux d'intérêt annuel
  const [savingTermMonths, setSavingTermMonths] = useState(1); // Durée de l'épargne en mois
  const [finalAmount, setFinalAmount] = useState(null); // Montant final calculé

  const calculateFinalAmount = () => {
    const P = initialAmount;
    const r = annualInterestRate / 100; // Convertir le taux annuel en taux mensuel et en décimal
    const n = savingTermMonths / 12; // La durée est déjà en mois

    // Vérifier si l'une des entrées est nulle ou zéro, ce qui rendrait le calcul invalide
    if (!P || !r || !n) {
      setFinalAmount("Entrée invalide");
      return;
    }

    const A = P * Math.pow(1 + r, n);

    setFinalAmount(isFinite(A) ? A : "Entrée invalide"); // Définir le montant final calculé
  };

  const isButtonDisabled =
    !initialAmount || !annualInterestRate || !savingTermMonths;

  return (
    <div className="simulator-container">
      <div className="simulateur-titre">{titre}</div>
      <div className="simulator">
        <div className="simulator-right">
          <Slider
            label="Versement mensuel:"
            unit="XOF"
            min={0}
            max={400000}
            stepCount={2} // Ajuster pour un défilement plus fluide
            value={initialAmount}
            setValue={setInitialAmount}
          />

          <Slider
            label="Taux de renumération:"
            unit="%"
            min={1}
            max={5}
            stepCount={4} // Ajuster pour un défilement plus fluide
            value={annualInterestRate}
            setValue={setAnnualInterestRate}
          />
          <Slider
            label="Durée de l'épargne:"
            unit="mois"
            min={0}
            max={60}
            stepCount={5} // Ajuster pour un défilement plus fluide
            value={savingTermMonths}
            setValue={setSavingTermMonths}
          />
          <div className="btn-container">
            <button
              onClick={calculateFinalAmount}
              className="btn-full"
              disabled={isButtonDisabled}
            >
              Lancer la simulation
            </button>
          </div>

          <NB />
        </div>
        {finalAmount !== null && (
          <div className="simulator-left animate__animated animate__zoomInUp">
            <div className="result-row">
              <h3>Montant initial:</h3>
              <div className="result-row-variable">
                {initialAmount.toLocaleString("fr-FR")} XOF
              </div>
            </div>
            <div className="result-row">
              <h3>Taux d'intérêt:</h3>
              <div className="result-row-variable">
                {annualInterestRate.toFixed(0)}%
              </div>
            </div>
            <div className="result-row">
              <h3>Durée de l'épargne:</h3>
              <div className="result-row-variable">
                {savingTermMonths.toFixed(0)} mois{" "}
              </div>
            </div>
            <div className="result-row">
              <h3>Montant final:</h3>
              <div className="result-row-variable final-result">
                {Math.floor(finalAmount).toLocaleString("fr-FR")} XOF{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimulateurEpargne;
